module.exports = __webpack_public_path__ + "img/best.29bda946.svg";